import { Pagination, Select } from "antd";
import NextPaginationIcon from "../../assets/icons/NextPaginationIcon";
import PrevPaginationIcon from "../../assets/icons/PrevPaginationIcon";
import SelectDownIcon from "../../assets/icons/SelectDownIcon";
import { selectSearchOption, selectStringOption } from "../../utils/utils";

interface CustomPaginationProps {
  limit: number;
  total: number;
  page?: number;
  hidePagination?: boolean;
  className?: string;
  handlePagination?: (paginationPage: number, paginationLimit: number) => void;
}

export default function CustomPagination({
  limit,
  total,
  page,
  hidePagination,
  className = "",
  handlePagination,
}: CustomPaginationProps) {
  if (!hidePagination && total && limit)
    return (
      <div
        className={`custom-pagination flex justify-between flex-wrap gap-2 px-4 py-2.5 ${className}`}
      >
        <div className="text-body text-sm font-semibold flex items-center gap-2.5">
          <span>Page</span>{" "}
          <span>
            <Select
              size="small"
              // showSearch
              value={page}
              onChange={(val) =>
                handlePagination && handlePagination(val, limit)
              }
              filterOption={selectSearchOption}
              options={selectStringOption(
                [...Array(Math.ceil(total / limit))].map(
                  (_, index) => `${index + 1}`
                ),
                "number"
              )}
              className="min-w-[52px] !bg-none"
              suffixIcon={<SelectDownIcon />}
            />
          </span>
          <span>of {Math.ceil(total / limit)}</span>
        </div>

        {/* Ant Design Pagination */}
        <Pagination
          total={total}
          current={page}
          pageSize={limit}
          showSizeChanger={false}
          onChange={handlePagination}
          itemRender={(_, type, __) => {
            if (type === "prev") return <PrevPaginationIcon />;
            if (type === "next") return <NextPaginationIcon />;
            return __;
          }}
        />
      </div>
    );

  return null;
}
